import React, { useState, useEffect } from "react";
import PolyProps from "./PolyPropss";
import pp from "../../assets/pp.png";
import pc1 from "../../assets/pc1.png";
import pc2 from "../../assets/pc2.png";
import flagPakistan from "../../assets/pakistan.png";
import flagJapan from "../../assets/japan.png";
import flagSaudiArabia from "../../assets/saudi_arabia.png";
import flagNorway from "../../assets/norway.png";
import flagUAE from "../../assets/united_arab_emirates.png";
import flagUSA from "../../assets/united_states_of_america.png";
import s1age4 from "../../assets/s1age4.png";
import s1age7 from "../../assets/s1age7.png";
import s1age11 from "../../assets/s1age11.png";
import s2age4 from "../../assets/s2age4.png";
import s2age7 from "../../assets/s2age7.png";
import s2age11 from "../../assets/s2age11.png";
// import s3age4 from "../../assets/s3age4.png";
// import s3age7 from "../../assets/s3age7.png";
// import s3age11 from "../../assets/s3age11.png";
import axios from 'axios';

const MentalMath = () => {
  const [competitionData, setCompetitionData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch competition data from database
  useEffect(() => {
    const fetchCompetitionData = async () => {
      try {
        const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/allpolymatchcompetition`);
        if (response.data && response.data.length > 0) {
          // Filter competitions that contain "math" or "mental" in the name (case insensitive)
          const mathCompetitions = response.data.filter(comp => 
            comp.Competition_Name && (
              comp.Competition_Name.toLowerCase().includes('math') ||
              comp.Competition_Name.toLowerCase().includes('mental')
            )
          );
          setCompetitionData(mathCompetitions);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching competition data:', error);
        setLoading(false);
      }
    };

    fetchCompetitionData();
  }, []);

  const headerSection = {
    mainHeading: "Global Math Competition",
    // subHeading: "Upcoming mental math competition in Nov 2025",
    mainImage: pp,
    leftImage: pc1,
    rightImage: pc2,
  };

  const upcomingCompetitionSection = {
    mainHeading: "For Our Upcoming Competition",
    subHeading: "Stay Tuned",
    competitionName: "Global Mental Math Competition",
    description:
      "The PolyMatch Global Mental Math Competition sharpens minds and celebrates numerical fluency from around the world. This exciting event brings together brilliant young mathematicians to tackle challenges in arithmetic, logic, and problem-solving. Encouraging speed, accuracy, and critical thinking, participants enhance their mathematical skills while building meaningful global connections in a dynamic and inspiring atmosphere.",
    registerLink: "/PolymatchReg",
    flags: [
      { src: flagPakistan, alt: "Pakistan Flag" },
      { src: flagJapan, alt: "Japan Flag" },
      { src: flagSaudiArabia, alt: "Saudi Arabia Flag" },
      { src: flagNorway, alt: "Norway Flag" },
      { src: flagUAE, alt: "United Arab Emirates Flag" },
      { src: flagUSA, alt: "United States of America Flag" },
    ],
  };

  // Dynamic competition years section based on database data
  const competitionYearsSection = {
    mainHeading: "Global Math Competition",
    defaultYear: 2024,
    years: competitionData.map(comp => ({
      year: new Date(comp.Competition_date).getFullYear(),
      title: comp.Competition_Name,
      dates: new Date(comp.Competition_date).toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }),
      description: comp.Competition_Description || "The PolyMatch Mental Math Competition was a huge success, with a big rise in global participation. It was a fun, high-energy event where kids showcased their amazing math skills and passion for learning.",
      competitionId: comp.Competition_Id,
    })),
    flags: [
      { src: flagPakistan, alt: "Pakistan Flag" },
      { src: flagJapan, alt: "Japan Flag" },
      { src: flagSaudiArabia, alt: "Saudi Arabia Flag" },
      { src: flagNorway, alt: "Norway Flag" },
      { src: flagUAE, alt: "United Arab Emirates Flag" },
      { src: flagUSA, alt: "United States of America Flag" },
    ],
  };

  const winnersSection = {
    mainHeading: "Congratulations to All Winners!",
    description:
      "We're proud of every participant, and we applaud the outstanding winners who showcased exceptional skills, creativity, and determination. Your hard work truly shines—well done!",
    winners: [
      // {
      //   year: 2024,
      //   image: 'Polymath-images/Winners Pics/2024/mental maths/5 to 7/1stPosition-AyeshaBasit.png',
      //   alt: "Age 5-7 Winner",
      //   ageCategory: "Ages 5-7",
      //   studentsData: [
      //     {
      //       name: "Ayesha Basit",
      //       rank: "1st Winner",
      //       country: "Karachi, Pakistan",
      //       age: "5 Years",
      //       image: 'Polymath-images/Winners Pics/2024/mental maths/5 to 7/1stPosition-AyeshaBasit.png',
      //     },
      //     {
      //       name: "Irtaza Haider",
      //       rank: "2nd Winner",
      //       country: "Karachi, Pakistan",
      //       age: "4 Years",
      //       image: 'Polymath-images/Winners Pics/2024/mental maths/5 to 7/2ndPosition-IrtazaHaider.png',
      //     },
      //     {
      //       name: "Hadi F Majeed",
      //       rank: "3rd Winner",
      //       country: "Karachi, Pakistan",
      //       age: "5 Years",
      //       image: 'Polymath-images/Winners Pics/2024/mental maths/5 to 7/3rdPosition-HadiFMajeed.png',
      //     },
      //   ],
      // },
       {
        year: 2024,
        image: 'Polymath-images/Winners Pics/2024/mental maths/5 to 7/1stPosition-AyeshaBasit.png',
        alt: "Age 5-7 Winner",
        ageCategory: "Ages 5 - 7",
        studentsData: [
          {
            name: "Ayesha Basit",
            rank: "1st Winner",
            country: "Islamabad, Pakistan",
            age: "7 Years",
            image: 'Polymath-images/Winners Pics/2024/mental maths/5 to 7/1stPosition-AyeshaBasit.png',
          },
          {
            name: "Irtaza Haider",
            rank: "2nd Winner",
            country: "Lahore, Pakistan",
            age: "7 Years",
            image: 'Polymath-images/Winners Pics/2024/mental maths/5 to 7/2ndPosition-IrtazaHaider.png',
          },
          {
            name: "Hadi F Majeed",
            rank: "3rd Winner",
            country: "Pakistan",
            age: "7 Years",
            image: 'Polymath-images/Winners Pics/2024/mental maths/5 to 7/3rdPosition-HadiFMajeed.png',
          },
        ],
      },
      {
        year: 2024,
        image: 'Polymath-images/Winners Pics/2024/mental maths/5 to 7/1stPosition-AyeshaBasit.png',
        alt: "Age 11-13 Winner",
        ageCategory: "Ages 8- 10",
        studentsData: [
          {
            name: "Sarim Atif",
            rank: "1st Winner",
            country: "Pakistan",
            age: "10 Years",
            image: 'Polymath-images/Winners Pics/2024/mental maths/8 to 10/1stPosition-SarimAtif.png',
          },
          {
            name: "Marium Imad",
            rank: "2nd Winner",
            country: "Pakistan",
            age: "8 Years",
            image: 'Polymath-images/Winners Pics/2024/mental maths/8 to 10/2ndPosition-MariumImad.png',
          },
          {
            name: "Iman Khan",
            rank: "3rd Winner",
            country: "Pakistan",
            age: "8 Years",
            image: 'Polymath-images/Winners Pics/2024/mental maths/8 to 10/3rdPosition-ImanKhan.png',
          },
        ],
      },
      {
        year: 2024,
        image: 'Polymath-images/Winners Pics/2024/mental maths/5 to 7/1stPosition-AyeshaBasit.png',
        alt: "Age 11 - 13 Winner",
        ageCategory: "Ages 11 - 13",
        studentsData: [
          {
            name: "Arsh Farooqn",
            rank: "1st Winner",
            country: "Karachi, Pakistan",
            age: "12 Years",
            image: 'Polymath-images/Winners Pics/2024/mental maths/11 to 13/1stPosition-ArshFarooq.png',
          },
          {
            name: "Inshirah Shahid",
            rank: "2nd Winner",
            country: "Pakisan",
            age: "12 Years",
            image: 'Polymath-images/Winners Pics/2024/mental maths/11 to 13/2ndPosition-InshirahShahid.png',
          },
          {
            name: "Hamnah Yousuf",
            rank: "3rd Winner",
            country: "Pakistan",
            age: "13 Years",
            image: 'Polymath-images/Winners Pics/2024/mental maths/11 to 13/3rdPosition-HamnahYousuf.png',
          },
        ],
      },
      {
        year: 2025,
        image: 'Polymath-images/Winners Pics/2025/mental maths/4/1stPosition-AyeshaBasit.png',
        alt: "Age 4 Winner",
        ageCategory: "Ages 4",
        studentsData: [
          {
            name: "Hussain Bin Ali",
            rank: "1st Winner",
            country: "Lahor, Pakistan",
            age: "4 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/4/Hussain_1st.png',
          },
          {
            name: "Muhammad Zahan Khan",
            rank: "2nd Winner",
            country: "Timgarah",
            age: "4 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/4/Muhammad_2nd.png',
          },
          {
            name: "Muhammad Ahil",
            rank: "3rd Winner",
            country: "Multan, Pakistan",
            age: "4 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/4/Muhammad_3rd.png',
          },
        ],
      },
      {
        year: 2025,
        image: 'Polymath-images/Winners Pics/2025/mental maths/5 to 6/Muhammad_1st.png',
        alt: "Age 5 to 6 Winner",
        ageCategory: "Ages 5 to 6",
        studentsData: [
          {
            name: "Muhammad Taha",
            rank: "1st Winner",
            country: "Rawalpindi, Pakistan",
            age: "6 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/5 to 6/Muhammad_1st.png',
          },
          {
            name: "Nrinoyi Sudhesh",
            rank: "2nd Winner",
            country: "Sharjah, UAE",
            age: "6 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/5 to 6/Nrinoyi_2nd.png',
          },
          {
            name: "Hiba Rashid",
            rank: "3rd Winner",
            country: "Lahore, Pakistan",
            age: "5 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/5 to 6/Hiba_3rd.png',
          },
        ],
      },
      {
        year: 2025,
        image: 'Polymath-images/Winners Pics/2025/mental maths/7 to 8/Areeb_1st.png',
        alt: "Age 7 to 8 Winner",
        ageCategory: "Ages 7 to 8",
        studentsData: [
          {
            name: "Areeb Ahmad",
            rank: "1st Winner",
            country: "Islamabad, Pakistan",
            age: "7 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/7 to 8/Areeb_1st.png',
          },
          {
            name: "Mujtaba Haider Kazmi",
            rank: "2nd Winner",
            country: "Lahore, Pakistan",
            age: "8 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/7 to 8/Mujtaba_2nd.png',
          },
          {
            name: "Muhammad Aabis Abbas",
            rank: "3rd Winner",
            country: "Islamabad, Pakistan",
            age: "7 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/7 to 8/M_3rd.png',
          },
        ],
      },
      {
        year: 2025,
        image: 'Polymath-images/Winners Pics/2025/mental maths/9 to 11/Abubaker_1st.png',
        alt: "Age 9 to 11 Winner",
        ageCategory: "Ages 9 to 11",
        studentsData: [
          {
            name: "Abubaker Alanesi",
            rank: "1st Winner",
            country: "Riyad, Saudia",
            age: "10 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/9 to 11/Abubaker_1st.png',
          },
          {
            name: "Manaa Nasir",
            rank: "2nd Winner",
            country: "Riyad, Saudia",
            age: "11 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/9 to 11/Manaa_2nd.png',
          },
          {
            name: "Maaz Ahmer",
            rank: "3rd Winner",
            country: "Karachi, Pakistan",
            age: "11 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/9 to 11/Maaz_3rd.png',
          },
        ],
      },
      {
        year: 2025,
        image: 'Polymath-images/Winners Pics/2025/mental maths/12 to 16/Abubaker_1st.png',
        alt: "Age 12 to 16 Winner",
        ageCategory: "Ages 12 to 16",
        studentsData: [
          {
            name: "Khuzaima Hassan",
            rank: "1st Winner",
            country: "Jhang, Sadar",
            age: "15 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/12 to 16/Khuzaima_1st.png',
          },
          {
            name: "Arsh Farooq",
            rank: "2nd Winner",
            country: "Karachi, Pakistan",
            age: "13 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/12 to 16/Arsh_2nd.png',
          },
          {
            name: "Aroon Kumar",
            rank: "3rd Winner",
            country: "Karachi, Pakistan",
            age: "15 Years",
            image: 'Polymath-images/Winners Pics/2025/mental maths/12 to 16/Aroon_3rd.png',
          },
        ],
      },
    ],
    resultsLink: "/PolymatchResults_Linguistic",
  };


  const spotlightSection = {
    mainHeading: "Participant Spotlight",
    subHeading: " – Watch Them in Action",
    description:
      "Get inspired by the creativity, confidence, and talent of our young competitors. These videos showcase real moments from PolyMatch participants sharing their experiences, solving challenges, and celebrating success.",
    participants: [
      {
        name: "Sarim Atif",
        compName: "Global Math Competition 2024",
        rank: "1st Winner – Age Category 9 - 11",
        country: "From Lahore",
        video: "https://www.youtube.com/shorts/74RS256bdNI?si=sU4tW6uPhCHaFB5D",
      },
      {
        name: "EMujtaba Khawaja",
        compName: "Global Math Competition 2024",
        rank: "1st Winner – Age Category 9 - 11",
        country: "From Pakistan",
        video: "https://www.youtube.com/shorts/2d1xM79n3Cc?si=jZy_QK_KA7mTC8kx",
      },
      {
        name: "Khadija Bashir",
        compName: "Global Math Competition 2024",
        rank: "3rd Winner – Age Category 4 - 6",
        country: "From Pakistan",
        video: "https://www.youtube.com/shorts/xNMPYI75lLY?si=0VVO8SXRhdBTxqAc",
      },
      {
        name: "Fathima Shamyl",
        compName: "Global Math Competition 2024",
        rank: "1st Winner – Age Category 4 - 6",
        country: "From UK",
        video: "https://www.youtube.com/shorts/jLs8BGEg170?si=O9oM3M5RQflI8Dny",
      },
      {
        name: "Emaan Omar",
        compName: "Global Math Competition 2024",
        rank: "3rd Winner – Age Category 9 - 11",
        country: "From Pakistan",
        video: null,
      },
      {
        name: "Emaan Omar",
        compName: "Global Math Competition 2024",
        rank: "3rd Winner – Age Category 9 - 11",
        country: "From Pakistan",
        video: null,
      },
    ],
  };

  // Show loading state while fetching data
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading competition data...
      </div>
    );
  }

  // Show message if no math competitions found
  if (!competitionData || competitionData.length === 0) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#666',
        textAlign: 'center',
        padding: '20px'
      }}>
        <div>
          <h3>No math competitions found</h3>
          <p>Please check back later for upcoming math competitions.</p>
        </div>
      </div>
    );
  }

  return (
    <PolyProps
      headerSection={headerSection}
      upcomingCompetitionSection={upcomingCompetitionSection}
      competitionYearsSection={competitionYearsSection}
      winnersSection={winnersSection}
      spotlightSection={spotlightSection}
      text={"Upcoming Event: November 2026"}
    />
  );
};

export default MentalMath;
